var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOrganizationUn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1043 9.3186H13.0103C13.1218 9.62391 13.1827 9.95339 13.1827 10.2968V14.4316C13.1827 14.5747 13.1578 14.7122 13.1124 14.84H14.9211C15.5967 14.84 16.1463 14.2903 16.1463 13.6147V11.3607C16.1464 10.2347 15.2303 9.3186 14.1043 9.3186Z",
    fill: "#2D81F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96368 10.2969C4.96368 9.95349 5.0246 9.62403 5.13612 9.31873H4.0421C2.91608 9.31873 2 10.2348 2 11.3608V13.6149C2 14.2905 2.54963 14.8401 3.22526 14.8401H5.03394C4.9886 14.7123 4.96368 14.5749 4.96368 14.4317V10.2969Z",
    fill: "#2D81F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3239 8.25476H7.82286C6.69685 8.25476 5.78076 9.17085 5.78076 10.2969V14.4316C5.78076 14.6572 5.96361 14.84 6.18918 14.84H11.9576C12.1832 14.84 12.366 14.6572 12.366 14.4316V10.2969C12.366 9.17085 11.45 8.25476 10.3239 8.25476Z",
    fill: "#2D81F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07307 2.84009C7.71889 2.84009 6.61719 3.94179 6.61719 5.29599C6.61719 6.21454 7.12416 7.01676 7.87287 7.43795C8.22799 7.63771 8.6374 7.75187 9.07307 7.75187C9.50873 7.75187 9.91814 7.63771 10.2733 7.43795C11.022 7.01676 11.5289 6.21451 11.5289 5.29599C11.5289 3.94182 10.4272 2.84009 9.07307 2.84009Z",
    fill: "#2D81F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7605 5.12915C3.74774 5.12915 2.92383 5.95306 2.92383 6.96582C2.92383 7.97858 3.74774 8.8025 4.7605 8.8025C5.0174 8.8025 5.26203 8.74928 5.48426 8.65363C5.86847 8.48821 6.18527 8.19539 6.3813 7.82861C6.5189 7.57119 6.59717 7.27751 6.59717 6.96582C6.59717 5.95309 5.77326 5.12915 4.7605 5.12915Z",
    fill: "#2D81F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3855 5.12915C12.3727 5.12915 11.5488 5.95306 11.5488 6.96582C11.5488 7.27754 11.6271 7.57121 11.7647 7.82861C11.9607 8.19542 12.2775 8.48824 12.6617 8.65363C12.884 8.74928 13.1286 8.8025 13.3855 8.8025C14.3983 8.8025 15.2222 7.97858 15.2222 6.96582C15.2222 5.95306 14.3983 5.12915 13.3855 5.12915Z",
    fill: "#2D81F7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrganizationUn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/organization-un.d2ccd5bd.svg";
export { ForwardRef as ReactComponent };